import React, {Component} from 'react';
import './stylesheet/Project.css';

class Project extends Component {
  render() {
    return (
      <div className="Project">
        <figure>
          <img
            src={this.props.img} alt={`${this.props.name} thumbnail`} />
          <div className="description">
            <div className="description-text">{this.props.description}</div>
          </div>
          <figcaption>{this.props.name}</figcaption>
          <div className="project-links">
            <a href={this.props.demo} target="_blank">Demo</a>
            <a href={this.props.github} target="_blank">Repo</a>
          </div>
        </figure>
      </div>
    )
  }
}

export default Project;



// WEBPACK FOOTER //
// ./src/components/Project.js